import { render, staticRenderFns } from "./Lesson6.vue?vue&type=template&id=2f613cb6&scoped=true&"
import script from "./Lesson6.vue?vue&type=script&lang=js&"
export * from "./Lesson6.vue?vue&type=script&lang=js&"
import style0 from "./Lesson6.vue?vue&type=style&index=0&id=2f613cb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f613cb6",
  null
  
)

export default component.exports